import React, { useCallback } from "react";

import { Product, SelectionGroup } from "../types/catalog";

interface SelectionGroupFormControlProps {
  selectionGroup: SelectionGroup;
  product: Product;
  quantity: number;
  onChangeQuantity: (newQuantity: number) => void;
  onCustomise: () => void;
  canIncrement: boolean;
  disabledButtons: boolean;
  children?: React.JSX.Element;
}

const SelectionGroupFormControl = ({
  selectionGroup,
  product,
  quantity,
  onChangeQuantity,
  onCustomise,
  canIncrement,
  children,
  disabledButtons,
}: SelectionGroupFormControlProps) : React.JSX.Element => {
  const keyVector = encodeURIComponent(`${selectionGroup.key}-${product.key}`);
  const onChange = useCallback((event: React.ChangeEvent) => {
    const target = event.target as HTMLInputElement;
    if (product.kind === "branch")
      onCustomise()
    else
      onChangeQuantity(target.checked ? 1 : 0);
  }, [product.kind, onCustomise, onChangeQuantity]);

  const onClick = useCallback((event: React.MouseEvent)=>{
    const target = event.target as HTMLInputElement;
    if (product.kind === "branch")
      onCustomise()
    else
      onChangeQuantity(target.checked ? 1 : 0);
  }, [product.kind, onCustomise, onChangeQuantity]);

  if (selectionGroup.minSelections === 1 && selectionGroup.maxSelections === 1) {
    return (
      <div className="radio">
        <input
          type="radio"
          name={encodeURIComponent(selectionGroup.key)}
          id={keyVector}
          checked={quantity === 1}
          readOnly={true}
          onClick={onClick}
          disabled={disabledButtons}
        />

        {children}
      </div>
    );
  } else if (product.kind === "branch" && quantity > 0) {
    return (
      <>{children}</>
    )
  } else if ((product.maxQuantity && product.maxQuantity === 1) || selectionGroup.maxSelections === 1) {
    return (
      <div className="checkbox">
        <input
          type="checkbox"
          name={encodeURIComponent(selectionGroup.key)}
          id={keyVector}
          checked={quantity === 1}
          readOnly={true}
          disabled={quantity !== 1 && !canIncrement || disabledButtons}
          onChange={onChange}
        />

        {children}
      </div>
    );
  } else {
    return <>{children}</>;
  }

}

export { SelectionGroupFormControl }
